import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { TypographyH1, TypographyH2 } from "@/components/ui/typography"
import { useAccountDelete } from "@/features/account"
import { useState } from "react"
import styles from "./styles.module.scss"
import { useAutoTranslation } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"

export const DeleteAccountPage = () => {
  const { t } = useAutoTranslation()
  const { handleSubmit, isLoading } = useAccountDelete()
  const [isChecked, setIsChecked] = useState(false)

  const onDeleteAccount = () => {
    const isSure = confirm(
      t(
        DISCOVERED_TRANSLATION_KEYS.ARE_YOU_SURE_YOU_WANT_TO_DELETE_YOUR_ACCOUNT
      )
    )
    if (!isSure) return
    handleSubmit()
  }

  return (
    <div className={styles.page}>
      <TypographyH1 className={styles.title}>
        {t(DISCOVERED_TRANSLATION_KEYS.DELETE_YOUR_ACCOUNT)}
      </TypographyH1>
      <TypographyH2 className={styles.description}>
        {t(
          DISCOVERED_TRANSLATION_KEYS.PLEASE_NOTE_ALL_OF_YOUR_DATA_WILL_BE_PERMANENTLY_REMOVED_FROM_OUR_SERVERS_FOREVER_THIS_ACTION_CANNOT_BE_UNDONE
        )}
      </TypographyH2>

      <div className={styles.checkboxRow}>
        <Checkbox
          id="delete-account-checkbox"
          checked={isChecked}
          onCheckedChange={checked => setIsChecked(!!checked)}
        />
        <Label htmlFor="delete-account-checkbox">
          {t(
            DISCOVERED_TRANSLATION_KEYS.I_UNDERSTAND_THAT_THIS_ACTION_CANNOT_BE_UNDONE
          )}
        </Label>
      </div>

      <Button
        onClick={onDeleteAccount}
        variant="destructive"
        isLoading={isLoading}
        disabled={!isChecked}
      >
        {t(DISCOVERED_TRANSLATION_KEYS.DELETE_ACCOUNT)}
      </Button>
    </div>
  )
}
